import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getAbstractProofsByOwnerOptions } from '@/module/Author/Abstract/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface AbstractOwnerProofListProps {
  abstractId: Id;
  userId: Id;
}

export function AbstractOwnerProofList({ abstractId, userId }: AbstractOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getAbstractProofsByOwnerOptions(abstractId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="abstract"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
